import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo-sm.png';
import { useConsent } from '../../context/ConsentContext';
import { SITE } from '../../config/site';
import AppearanceSwitch from '../../theme/AppearanceSwitch';

const COLUMNS = [
  { title: 'Product', links: [
    ['Spectral library', '/spectral-library'],
    ['Analyse a spectrum', '/spectral-library/analyse'],
    ['Desktop app', '/software/desktop-application'],
    ['SCOUT instrument', '/analyser/SCOUT'],
    ['Pricing', '/pricing'],
  ] },
  { title: 'Resources', links: [
    ['Documentation', '/documentation'],
    ['Research & impact', '/research-impact'],
    ['News', '/news'],
  ] },
  { title: 'Company', links: [
    ['About us', '/about'],
    ['Invest', '/invest'],
    ['Contact', '/contact-us'],
  ] },
];

export default function Footer() {
  const { openSettings } = useConsent();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-night text-white">
      <div className="container-page py-16 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="max-w-sm">
            <Link to="/" className="inline-flex items-center gap-2.5">
              <span className="rounded-2xl bg-white p-1.5"><img src={logo} alt="" className="h-6 w-auto" width="39" height="24" decoding="async" loading="lazy" /></span>
              <span className="font-semibold tracking-tight">Plastic Analytics</span>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              Open spectral library and AI analysis for identifying microplastics with Raman and FTIR spectroscopy.
            </p>
            <div className="mt-6 flex gap-2">
              <a href={SITE.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Plastic Analytics on LinkedIn"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 transition hover:bg-white/20 hover:text-white">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" /><circle cx="4" cy="4" r="2" /></svg>
              </a>
              <a href={SITE.social.x} target="_blank" rel="noopener noreferrer" aria-label="Plastic Analytics on X"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 transition hover:bg-white/20 hover:text-white">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.8l-5.33-6.97L4.8 22H1.54l8.02-9.17L1 2h6.97l4.82 6.37L18.244 2Zm-1.19 18h1.88L7.03 3.9H5.01L17.054 20Z" /></svg>
              </a>
            </div>
          </div>
          {COLUMNS.map((c) => (
            <nav key={c.title} aria-label={c.title}>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-white/40">{c.title}</p>
              <ul className="mt-4 space-y-3">
                {c.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-white/70 transition hover:text-white">{label}</Link></li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-16 flex flex-col gap-6 border-t border-white/10 pt-8 text-sm text-white/50 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-4">
            <AppearanceSwitch onDark />
            <p>© {year} {SITE.name} · Operated by {SITE.operator}, France</p>
          </div>
          <nav aria-label="Legal" className="flex flex-wrap gap-x-6 gap-y-3">
            <Link to="/privacy-policy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/cookies" className="hover:text-white">Cookies</Link>
            <Link to="/legal-notice" className="hover:text-white">Legal notice</Link>
            <button type="button" onClick={openSettings} className="hover:text-white">Cookie settings</button>
          </nav>
        </div>
      </div>
    </footer>
  );
}
